<template>
<v-card outlined>
    <v-card-text>
        <v-form ref="form" v-model="valid" class="d-flex align-center flex-wrap" style="width: 100%">
            <div class="mr-3">
                <v-select
                    :items="tipoJuegoList"
                    item-text="name"
                    item-value="id"
                    clearable
                    label="Tipo Juego"
                    v-model="fields.tipo_juego_id"
                    @change="changed('tipo_juego_id', $event)"
                    hide-details
                    filled
                    :disabled="loading"
                    dense
                    >
                </v-select>
            </div>
            <div class="mr-3">
                <v-select
                    :items="loteriaList"
                    item-text="name"
                    item-value="id"
                    clearable
                    label="Loteria"
                    v-model="fields.loteria_id"
                    hide-details
                    filled
                    :disabled="loading"
                    @change="changed('loteria_id')"
                    dense
                    >
                </v-select>
            </div>
            <div class="mr-3">
                <v-select
                    :items="isActiveList"
                    filled
                    hide-details
                    label="Estado"
                    clearable
                    v-model="fields.is_active"
                    :disabled="loading"
                    @change="changed('is_active')"
                    dense
                    >
                </v-select>
            </div>
            <div class="mr-3">
                <v-text-field
                    v-model="fields.search"
                    append-icon="mdi-magnify"
                    filled
                    label="Buscar Juego"
                    hide-details
                    clearable
                    :disabled="loading"
                    @change="changed('search')"
                    dense
                    >
                </v-text-field>
            </div>
        </v-form>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
        <v-spacer/>
        <v-btn text class="mr-3" :disabled="loading" @click="reset()" small>Reiniciar Filtros</v-btn>
        <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()" small><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import LoteriaService from '@services/loteria/LoteriaService';
import TipoJuegoService from '@services/loteria/TipoJuegoService';
import Search from '@mixins/search';

const defaultValues = {
    search: null,
    is_active: null,
    tipo_juego_id: null,
    loteria_id: null,
};

export default {
    components: {
    },
    props: {
        loading: {},
    },
    mixins: [Search],
    data: function ()  {
        return {
            defaultFields: {... defaultValues},
            
            tipoJuegoListLoading: false,
            tipoJuegoList: [],

            loteriaListLoading: false,
            loteriaList: [],

            isActiveList: [
                {
                    text: 'Todos',
                    value: null,
                },
                {
                    text: 'Activo',
                    value: true,
                },
                {
                    text: 'Inactivo',
                    value: false,
                }
            ],
        }
    },
    mounted: function () {
        this.getTipoJuegoList();
        this.getLoteriaList();
    },
    methods: {
        getTipoJuegoList: function () {
            this.tipoJuegoListLoading = true;
            TipoJuegoService.getList({ is_active: true })
                .then(({ tipoJuegoList }) => {
                    this.tipoJuegoList = tipoJuegoList;
                }).finally(() => {
                    this.tipoJuegoListLoading = false;
                });
        },
        getLoteriaList: function () {
            this.loteriaListLoading = true;
            LoteriaService.getList({ is_active: true })
                .then(({ loteriaList }) => {
                    this.loteriaList = loteriaList;
                }).finally(() => {
                    this.loteriaListLoading = false;
                });
        },
    },
}
</script>

<style>

</style>